import { YellowBaloon } from '../Icons'
import './index.scss'

const Loading = () => (
    <div className="decode-loading">
        <YellowBaloon />
    </div>
)

export default Loading